<script lang="ts">
import { defineComponent } from 'vue';
import { BetSlipRejectStatus } from '@/types/coupons.enum';
import ColoredNumber from '@/components/colored-number.vue';
import Chip from '@/components/chip.vue';
import HiddenBlock from '@/components/hidden-block.vue';
import ClipboardIcon from '@/components/clipboard-icon.vue';

export default defineComponent({
  name: 'row-stake-number',
  components: { ClipboardIcon, Chip },
  computed: {
    BetSlipRejectStatus() {
      return BetSlipRejectStatus;
    },
  },
  props: ['stake', 'index'],
});
</script>

<template>
  <span class="col-span-3">
    <chip class="bg-slate-400 dark:bg-slate-500" :value="stake.type" />
    <chip
      v-if="stake.rejectStatus === BetSlipRejectStatus.Rejected"
      class="bg-red-500 dark:bg-rose-500 ml-1"
      value="Отказано"
    />
    <span class="text-gray-500 ml-1">{{ stake.guid }}</span>
    <clipboard-icon :text="stake.guid" class="ml-1" />
  </span>
</template>

<style scoped lang="scss"></style>
